import { api, ApiResponse } from 'components/api'
import { contentVisits } from 'components/routes/path'

export interface CreateContentVisitParams {
  event_type: string
  href?: string
  supplier_id?: number
}

export const createContentVisit = async (inputParams: CreateContentVisitParams): Promise<ApiResponse<unknown>> => {
  const params = { ...inputParams, path: window.location.pathname, query_string: window.location.search }
  return await api.postWithCsrf({
    url: contentVisits(),
    data: {},
    headers: { Accept: 'application/json' },
    params
  })
}
